import { render, staticRenderFns } from "./BankAccountCard.vue?vue&type=template&id=29024ed3"
import script from "./BankAccountCard.vue?vue&type=script&lang=js"
export * from "./BankAccountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsBankCard: require('/app/components/Commons/BankCard.vue').default,Theme2ComponentsBankCryptoAddEmptyCard: require('/app/components/Theme2/Components/BankCryptoAddEmptyCard.vue').default})
